<template>
  <div class="operating-equipment">
    <p class="title-text">
      {{ $t('components.stepper_business.sub_steps.title') }}
    </p>

    <p class="subtitle-text">
      {{ $t('components.stepper_business.sub_steps.operating_equipment.title') }}
    </p>
    <form-operating-equipment v-if="checkBusinessKind" />
    <waste-merchant-operating-equipment v-else />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FormOperatingEquipment from '@/components/forms/register/business/operational_capacity/FormOperatingEquipment.vue';
import WasteMerchantOperatingEquipment from '@/components/forms/register/business/operational_capacity/waste_merchant/WasteMerchantOperatingEquipment.vue';

export default {
  name: 'OperatingEquipment',
  components: {
    FormOperatingEquipment,
    WasteMerchantOperatingEquipment,
  },
  computed: {
    ...mapGetters([
      'getBusiness',
    ]),
    checkBusinessKind() {
      return this.getBusiness.kind === 'cooperative_association';
    },
  },
};
</script>

<style lang="scss" scoped>
.operating-equipment {
  padding-left: 8px;
  margin: 20px;
  .title-text {
    color: $title_color_primary;
    margin-bottom: 64px;
    margin-top: 40px;
    font-size: 1.8em;
    font-weight: bold;
  }
  .subtitle-text {
    color: $title_color_primary;
    margin-bottom: 30px;
    font-size: 1.5em;
    font-weight: 600;
  }
}
</style>
